export const extractTags = (items = []) => {

  const tags = [];

  items.forEach((item) => {

    if (item.tags) {

      item.tags
        .split(',')
        .forEach((tag) => {

          const clean =
            tag.trim();

          if (
            clean &&
            !tags.includes(clean)
          ) {

            tags.push(clean);

          }

        });

    }

  });

  return tags.sort();

};

export const addTagToField = (
  currentTags,
  tag
) => {

  const tagsActuales =
    (currentTags || '')
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean);

  if (
    tagsActuales.includes(tag)
  ) {

    return currentTags;

  }

  return [

    ...tagsActuales,
    tag

  ].join(', ');

};

export const normalizeTags = (
  tags
) => {

  return (tags || '')
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean);

};